import type { AuthUser } from '@/types/auth.types';
import { isAdminRole, normalizeUserRole } from '@/lib/auth/roles';

export type NavRole = 'guest' | 'user' | 'collector' | 'moderator' | 'admin' | 'accountant';

export function resolveNavRole(user: AuthUser | null): NavRole {
  if (!user) return 'guest';
  const role = normalizeUserRole(user.role);
  if (isAdminRole(role)) return 'admin';
  if (role === 'collector') return 'collector';
  if (role === 'moderator') return 'moderator';
  if (role === 'accountant') return 'accountant';
  return 'user';
}

export function resolveAdminLabel(user: AuthUser | null, fallback: string, superAdminLabel = fallback): string {
  return normalizeUserRole(user?.role) === 'super_admin' ? superAdminLabel : fallback;
}

export function isAdmin(user: AuthUser | null): boolean {
  return Boolean(user && isAdminRole(user.role));
}

export function isModerator(user: AuthUser | null): boolean {
  return Boolean(user && normalizeUserRole(user.role) === 'moderator');
}

export function isAccountant(user: AuthUser | null): boolean {
  return Boolean(user && normalizeUserRole(user.role) === 'accountant');
}

export function isCollector(user: AuthUser | null): boolean {
  return Boolean(user && normalizeUserRole(user.role) === 'collector');
}
